<template>
  <div>
    <h1 class="title mqu-subtitle">
      Outgoing/Exit Fees
    </h1>
    <h2 class="subtitle">
      Most villages charge an <b-tooltip label="This may also be called a departure fee, deferred management fee, deferred fee or some other name." :multilined="true" :animated="true" type="is-warning"><a>outgoing/exit fee</a></b-tooltip> when you leave the village. This reduces the amount of your refund. The fee is usually a percentage of either the ingoing fee or of the resale value. The percentage fee usually depends on how long you live in the <b-tooltip label="Usually it is a fixed percentage rate per year for a fixed numbed of years. For instance, it could be 6% per year for years 1 to 5. Or it could be at different rates over different periods. For instance 10% per year for years 1 to 2, then 2% per year for years 3 to 7." :multilined="true" :animated="true" type="is-warning"><a>village</a></b-tooltip>.
    </h2>
    <rv-has name="has-outgoing-fee" label="Are you charged an outgoing/exit fee when you leave the village?" v-model="data.hasOutgoingFees"/>
    <transition name="fade" mode="out-in">
      <div v-if="data.hasOutgoingFees">
        <outgoing-fee-type v-model="data.outgoingFeeType" v-on:input="update"/>
        <outgoing-fee v-model="data.outgoingFee" v-on:input="update"/>
        <rv-radio :validation-rule="{required: true}" label="Do you wish to use the calculated maximum outgoing fee percentage?" :option-a="true" :option-b="false" v-model="data.useCalculatedMax">
          <template slot="option-b">
            <span>Enter my own</span>
          </template>
          <template slot="option-a">
            <span>Yes ({{calculatedMax}}%)</span>
          </template>
        </rv-radio>
        <maximum-outgoing-fee v-if="data.useCalculatedMax === false" v-model="data.maximumOutgoingFee" v-on:input="update"/>
      </div>
    </transition>
  </div>
</template>

<script>
import OutgoingFee from '../inputs/outgoing-fees/OutgoingFee'
import MaximumOutgoingFee from '../inputs/outgoing-fees/MaximumOutgoingFee'
import OutgoingFeeType from '../inputs/outgoing-fees/OutgoingFeeType'
import RvHas from '../inputs/RvHas'
import RvRadio from '../inputs/RvRadio'
// import MinimumOutgoingFee from '../inputs/outgoing-fees/MinimumOutgoingFee'

export default {
  props: ['value'],
  inject: ['$validator'],
  created() {
    this.calculatedMax = 0
    for (let i = 0; i < this.data.outgoingFee.length; i++) {
      this.calculatedMax +=
        this.data.outgoingFee.list[i].rate *
        (this.data.outgoingFee.list[i].toYear - this.data.outgoingFee.list[i].fromYear + 1)
    }
    console.log(this.calculatedMax)
    if (this.calculatedMax > 100) {
      this.calculatedMax = 100
    }
    if (this.data.useCalculatedMax === true) {
      this.data.maximumOutgoingFee = this.calculatedMax.toString()
      this.refreshHack = false
      this.$nextTick(() => {
        this.refreshHack = true
      })
    }
    this.update()
  },
  components: {
    // MinimumOutgoingFee,
    RvHas,
    OutgoingFeeType,
    MaximumOutgoingFee,
    OutgoingFee,
    RvRadio
  },
  data() {
    return {
      refreshHack: true,
      calculatedMax: 0,
      data: {
        useCalculatedMax: this.value.useCalculatedMax,
        hasOutgoingFees: this.value.hasOutgoingFees,
        outgoingFeeType: this.value.outgoingFeeType,
        maximumOutgoingFee: this.value.maximumOutgoingFee,
        minimumOutgoingFee: '0',
        outgoingFee: this.value.outgoingFee
      }
    }
  },
  methods: {
    update: function() {
      this.$emit('input', this.data)
    },
    updateMax: function() {
      this.data.maximumOutgoingFee = this.calculatedMax.toString()
      this.update()
    }
  },
  watch: {
    'data.hasOutgoingFees': function() {
      this.update()
    },
    'data.outgoingFee': {
      handler: function() {
        this.calculatedMax = 0
        for (let i = 0; i < this.data.outgoingFee.length; i++) {
          this.calculatedMax +=
            this.data.outgoingFee.list[i].rate *
            (this.data.outgoingFee.list[i].toYear - this.data.outgoingFee.list[i].fromYear + 1)
        }
        console.log(this.calculatedMax)
        if (this.calculatedMax > 100) {
          this.calculatedMax = 100
        }
        if (this.data.useCalculatedMax === true) {
          this.data.maximumOutgoingFee = this.calculatedMax.toString()
          this.refreshHack = false
          this.$nextTick(() => {
            this.refreshHack = true
          })
        }
        this.update()
      },
      deep: true
    },
    'data.useCalculatedMax': function() {
      if (this.data.useCalculatedMax === true) {
        this.data.maximumOutgoingFee = this.calculatedMax.toString()
      } else {
        this.data.maximumOutgoingFee = '0'
      }
      this.refreshHack = false
      this.$nextTick(() => {
        this.refreshHack = true
      })
      this.update()
    }
  }
}
</script>

<style scoped>
.mqu-title {
  font-family: 'National-Extrabold';
}

.mqu-subtitle {
  font-family: 'National-Light';
}
</style>



// WEBPACK FOOTER //
// src/components/modules/stages/OutgoingFees.vue